import mixpanelBrowser, { Callback, Mixpanel } from 'mixpanel-browser';
import { MIXPANEL_API_KEY } from 'utils/constants/mixpanel';

type UserInfo = Parameters<typeof mixpanelBrowser.people.set>[0];

export namespace mixpanel {
  let initialized = false;

  export type TrackCallback = Callback;

  let people: Mixpanel['people'] | null;

  export const init = () => {
    if (MIXPANEL_API_KEY && !initialized) {
      mixpanelBrowser.init(MIXPANEL_API_KEY, {
        autocapture: {
          pageview: 'full-url',
          click: true,
          input: true,
          scroll: true,
          submit: true,
          capture_text_content: true,
        },
        flags: true,
        // Configure session recording but don't auto-start it
        record_sessions_manually: true,
        record_mask_text_selector: '[data-mask-text]',
        record_mask_text_class: 'mask-text',
        // Enable heatmap data collection
        record_heatmap_data: true,
        // Collect fonts for better session replay rendering
        record_collect_fonts: true,
      } as any);

      people = mixpanelBrowser.people;

      initialized = true;
    }
  };

  export const setPeople = function (userInfo: UserInfo) {
    people?.set(userInfo);
  };

  export const identify: Mixpanel['identify'] = function (...args) {
    mixpanelBrowser.identify(...args);
  };

  export const track: Mixpanel['track'] = function (...args) {
    mixpanelBrowser.track(...args);
  };

  export const getVariantValue = async (
    flagName: string,
    fallback?: string,
  ): Promise<string | undefined> => {
    try {
      return await mixpanelBrowser.flags.get_variant_value(flagName, {
        fallback,
      });
    } catch (error) {
      return fallback;
    }
  };

  // Session recording methods
  export const startRecording = () => {
    if (initialized && mixpanelBrowser.start_session_recording) {
      mixpanelBrowser.start_session_recording();
    }
  };

  export const stopRecording = () => {
    if (initialized && mixpanelBrowser.stop_session_recording) {
      mixpanelBrowser.stop_session_recording();
    }
  };

  export const isRecording = (): boolean => {
    if (initialized && mixpanelBrowser.get_session_recording_properties) {
      const props = mixpanelBrowser.get_session_recording_properties();
      return props &&
        typeof props === 'object' &&
        '$session_recording_enabled' in props
        ? props['$session_recording_enabled' as keyof typeof props] === true
        : false;
    }
    return false;
  };
}
